import { ITimeUnitsEnum } from 'types/graphqlTypes'

export const parseSnoozePeriod = (snoozeUntil: string): [number, ITimeUnitsEnum] => {
  const [snoozePeriodValue, snoozePeriodUnit] = snoozeUntil?.split(' ') || []
  return [Number(snoozePeriodValue), snoozePeriodUnit as ITimeUnitsEnum]
}
